import { render, staticRenderFns } from "./MenuFrame.vue?vue&type=template&id=7a5eef76&scoped=true"
import script from "./MenuFrame.vue?vue&type=script&lang=js"
export * from "./MenuFrame.vue?vue&type=script&lang=js"
import style0 from "./MenuFrame.vue?vue&type=style&index=0&id=7a5eef76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5eef76",
  null
  
)

export default component.exports